import React from "react";
import Navbar from "./Navbar";
import project1 from "../images/lapizza.png";
import project2 from "../images/githubfinder.png";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Chip,
} from "@material-ui/core";

const useStyles = makeStyles({
  mainContainer: {
    background: "#233",
    minHeight: "100vh",
    padding: "3rem 0",
  },
  cardContainer: {
    maxWidth: 500,
    width: "90%",
    margin: "2rem auto",
    transition: "0.3s",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
    },
  },
  chipContainer: {
    marginTop: "0.5rem",
    "& > *": {
      marginRight: "0.5rem",
      marginBottom: "0.5rem",
    },
  },
  comingSoonText: {
    textAlign: "center",
    color: "#ccc",
    marginTop: "3rem",
    fontStyle: "italic",
  },
});

const projects = [
  {
    title: "LA PIZZA RESTRO",
    image: project1,
    description: "Experience the best pizzas in Portugal!",
    demoLink: "https://lapizza.pt/",
    tech: ["React", "JS", "Express", "MongoDB", "Email.js"],
  },
  {
    title: "GitHub Account Finder",
    image: project2,
    description: "Find Github user accounts with this app",
    demoLink: "https://pukarhubfinder.netlify.app/",
    tech: ["html", "css", "JavaScript", "GitHub API"],
  },
];

const Portfolio = () => {
  const classes = useStyles();

  return (
    <>
      <Navbar />
      <Box className={classes.mainContainer}>
        <Grid container justifyContent="center" spacing={4}>
          {projects.map((project, index) => (
            <Grid item xs={12} sm={10} md={6} key={index}>
              <Card className={classes.cardContainer}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt={project.title}
                    height="250"
                    image={project.image}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      style={{ color: "#00e0ff" }}
                    >
                      {project.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                    >
                      {project.description}
                    </Typography>

                    {/* Tech Chips */}
                    {project.tech && (
                      <Box className={classes.chipContainer}>
                        {project.tech.map((techItem, idx) => (
                          <Chip key={idx} label={techItem} color="primary" />
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </CardActionArea>

                <CardActions>
                  {project.demoLink && (
                    <Button
                      size="small"
                      color="primary"
                      component="a"
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Live Demo
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography className={classes.comingSoonText}>
          More projects coming soon…{" "}
          <span role="img" aria-label="rocket">
            🚀
          </span>
        </Typography>
      </Box>
    </>
  );
};

export default Portfolio;
